import modalMixin from '../../mixins/_modal';

/**
 * モーダルの枠組み付きコンポーネント
 */
export default {
    // see resources/views/components/_vue_modal.blade.php
    template: '#modal_template',
    data() {
        return {
            // 編集中のデータ
            data: {}
        };
    },
    props: {
        // モーダルのID指定
        id: {
            type: String,
            default: '',
            required: false
        },
        // 更新ボタンを表示
        show_update_button: {
            type: Boolean,
            default: true,
            required: false
        },
        // slotで使える変数(モーダル内で編集するデータ)
        modelValue: {
            type: Object,
            default: () => ({}),
            required: false
        }
    },
    mixins: [
        modalMixin
    ],
    computed: {
        // データがセットされているか
        isNotEmptyData: function() {
            return (Object.keys(this.data).length > 0);
        }
    },
    emits: ['update:modelValue'],
    /**
     * 各種メソッド
     */
    methods: {
        // モーダルを開いたら編集中データへ代入
        opening: function () {
            this.data = _.cloneDeep(this.modelValue);
        },
        // データを更新してモーダルを閉じる
        update: function (event) {
            // formタグで挟んでいてrequireエラーの場合はそのままフォーム送信する
            if (event?.target?.form !== null && !event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();
            this.emitUpdateValue();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdateValue: function () {
            this.$emit('update:modelValue', this.data);
        }
    },
};
